export default __webpack_public_path__ + "static/media/music_light.b661d81e.png";